import React from 'react';
import { TrendingUp, Target, AlertTriangle, BarChart2 } from 'lucide-react';

const kpis = [
  {
    id: 'bt-kpi-winrate',
    label: 'Win Rate',
    value: '61.4%',
    sub: '54W / 34L · 88 total trades',
    icon: <Target size={16} />,
    variant: 'positive' as const,
  },
  {
    id: 'bt-kpi-pf',
    label: 'Profit Factor',
    value: '2.18',
    sub: 'Gross $42,810 / $19,640',
    icon: <TrendingUp size={16} />,
    variant: 'positive' as const,
  },
  {
    id: 'bt-kpi-trades',
    label: 'Net Return',
    value: '+$23,170',
    sub: '$25,000 initial · +92.7%',
    icon: <BarChart2 size={16} />,
    variant: 'positive' as const,
  },
  {
    id: 'bt-kpi-dd',
    label: 'Max Drawdown',
    value: '-$4,820',
    sub: '-19.3% · Mar 2025 drawdown period',
    icon: <AlertTriangle size={16} />,
    variant: 'warning' as const,
  },
];

export default function BacktestKPICards() {
  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3">
      {kpis.map((kpi) => (
        <div
          key={kpi.id}
          className={`rounded-xl border p-4 transition-all duration-200 ${
            kpi.variant === 'warning' ?'bg-warning-subtle border-warning/30 card-glow-warning' :'bg-card border-border card-glow-primary'
          }`}
        >
          <div className={`inline-flex p-1.5 rounded-lg mb-3 ${
            kpi.variant === 'warning' ? 'bg-warning/10 text-warning' : 'bg-primary/10 text-primary'
          }`}>
            {kpi.icon}
          </div>
          <p className="text-xs font-500 text-muted-foreground uppercase tracking-wider mb-1">{kpi.label}</p>
          <p className={`text-xl font-bold font-mono-nums ${
            kpi.variant === 'warning' ? 'text-warning' : kpi.value.startsWith('+') ? 'text-positive' : 'text-foreground'
          }`}>
            {kpi.value}
          </p>
          <p className="text-xs text-muted-foreground mt-1 font-mono-nums">{kpi.sub}</p>
        </div>
      ))}
    </div>
  );
}